export const UNLOCK_PDF_TOOL = 'unlock-pdf';

export const UNLOCK_PDF_PROCESSING_DURATION_MS = 30000;

export const UNLOCKED_FILE_TOAST_DURATION_MS = 3000;

export const UNLOCKED_FILE_TOAST_FADE_MS = 300;

const completedProcessingFiles = new WeakSet<File>();

export const hasCompletedUnlockPdfProcessing = (file: File) =>
  completedProcessingFiles.has(file);

export const markUnlockPdfProcessingComplete = (file: File) => {
  completedProcessingFiles.add(file);
};
